/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { GetTypeConfigurationRequest } from './types';
import { FileTypesRecord } from '../store/admin/file-type-configuration/types';
import { FileTypeConfigResponse } from '../entities/file-type-configurations-v1/models';
import { axiosInstance } from "../axios-instance";

class FileTypeConfiguration {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getFileTypeConfigurationRecords(
    input: GetTypeConfigurationRequest,
  ): Promise<AxiosResponse<FileTypeConfigResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<FileTypeConfigResponse>(`${this.baseUrl}/fileTypeConfigs`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  createFileTypeConfiguration(
    input: FileTypesRecord
  ): Promise<AxiosResponse<FileTypesRecord>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<FileTypesRecord>(`${this.baseUrl}/fileTypeConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
    }})
    .catch((error) => {
      throw new Error(error);
  });
  }

  editFileTypeConfiguration(
    input: FileTypesRecord
  ): Promise<AxiosResponse<FileTypesRecord>> {
    const accessToken = localStorage.getItem('accessToken');
    const {fileTypeId, ...inputWithoutFileTypeId} = input
    return axiosInstance.put<FileTypesRecord>(`${this.baseUrl}/fileTypeConfigs/${fileTypeId}`, inputWithoutFileTypeId, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
    }})
    .catch((error) => {
        throw new Error(error);
    })
  }
}

export default FileTypeConfiguration;
